import { z } from 'zod';
import { CurrencySchema } from './common.js';

const IdiomaSchema = z.enum(['es', 'pt']);

export const CreateClientSchema = z.object({
  razaoSocial: z.string().min(1),
  nomeFantasia: z.string().optional(),
  docFiscal: z.string().optional(),
  email: z.string().email().optional(),
  telefone: z.string().optional(),
  whatsapp: z.string().optional(),
  endereco: z.string().optional(),
  cidade: z.string().optional(),
  pais: z.string().default('PY'),
  condicaoPagamentoDias: z.number().int().min(0).default(30),
  moeda: CurrencySchema.default('USD'),
  idioma: IdiomaSchema.default('es'),
  representanteId: z.string().uuid().optional(),
});
export type CreateClientDTO = z.infer<typeof CreateClientSchema>;

export const UpdateClientSchema = CreateClientSchema.partial();
export type UpdateClientDTO = z.infer<typeof UpdateClientSchema>;

export const ClientViewSchema = z.object({
  id: z.string().uuid(),
  razaoSocial: z.string(),
  nomeFantasia: z.string().nullable(),
  docFiscal: z.string().nullable(),
  email: z.string().nullable(),
  telefone: z.string().nullable(),
  whatsapp: z.string().nullable(),
  endereco: z.string().nullable(),
  cidade: z.string().nullable(),
  pais: z.string(),
  condicaoPagamentoDias: z.number(),
  moeda: CurrencySchema,
  idioma: IdiomaSchema,
  representanteId: z.string().uuid().nullable(),
});
export type ClientViewDTO = z.infer<typeof ClientViewSchema>;
